import { processLazyPreloader } from '../../shared/process-lazy-preloader.js';
export default function onLoad(e) {
  var swiper = this;
  processLazyPreloader(swiper, e.target);

  if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) {
    return;
  }

  swiper.update();
}